import { Form, Formik } from 'formik';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled
} from '@material-ui/core';

import React, { useState } from 'react';

import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import FormDialog from './FormDialog';
import { CpanelSchema } from './validation';
import FormikTextField from './FormikTextField';
import { useDomains } from '../../hooks/domains';
import ActionButton from '../buttons/ActionButton';
import SubmitButton from '../buttons/SubmitButton';
import Copy from '../Copy';
import { useCreateCpanel } from '../../hooks/cpanel';
import { PrimaryCheckboxInput } from '../CheckboxMenu';

const initialValues = {
  customDomain: '',
  email: '',
  name: ''
};

const CpanelForm = ({ resource, currentProject, handleClose, open }) => {
  const [inputValue, setValue] = useState('');
  const [openForm, setOpen] = useState(true);
  const [CheckboxData, setCheckboxDataState] = useState(true);

  // handle selection
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const DomainData = useDomains(currentProject);
  const domains = DomainData?.data?.domains;

  const domainNames = domains?.map((domain) => domain.name);

  const createCpanelMutation = useCreateCpanel();

  const isEditMode = Boolean(resource);

  const CopyContainer = styled('div')({
    minWidth: 'auto'
  });

  let resolvedInitialValues = {
    ...initialValues
  };
  if (isEditMode) {
    const { name, email, customDomain } = resource;

    resolvedInitialValues = {
      ...initialValues,
      customDomain,
      email,
      name
    };
  }

  const handleSubmit = (values, action) => {
    const options = {
      onError: handleClose,
      onSuccess: () => {
        action.resetForm();
        handleClose();
      }
    };

    createCpanelMutation.mutate(
      {
        aRecord: values.aRecord,
        autoSetting: CheckboxData,
        cnameRecord: values.cnameRecord,
        domainName: inputValue === 'other' ? values.customDomain : inputValue,
        email: values.email,
        projectId: currentProject
      },
      options
    );
  };

  const BootstrapInput = withStyles((theme) => ({
    input: {
      '&:focus': {
        borderColor: '#80bdff',
        borderRadius: '0.75rem',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
      },
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      borderRadius: '0.75rem',
      fontFamily: ['inherit'].join(','),
      fontSize: 16,
      padding: '17px 26px 18px 12px',
      position: 'relative',
      transition: theme.transitions.create(['border-color', 'box-shadow'])
    },
    root: {
      'label + &': {
        marginTop: theme.spacing(3)
      }
    }
  }))(InputBase);

  const isCreated = createCpanelMutation.isSuccess === true;
  if (!isCreated) {
    return (
      <FormDialog fullWidth onClose={handleClose} open={open}>
        <DialogTitle>{`${isEditMode ? 'Edit' : 'Add'} Cpanel`}</DialogTitle>
        <Formik
          initialValues={resolvedInitialValues}
          onSubmit={handleSubmit}
          validationSchema={CpanelSchema}
        >
          {({ isSubmitting, dirty, isValid }) => (
            <Form>
              <DialogContent>
                <DialogContentText>Please fill cpanel information</DialogContentText>
                <Box>
                  <Select
                    fullWidth
                    input={<BootstrapInput />}
                    onChange={handleChange}
                    value={inputValue}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {domainNames.map((domainName, index) => (
                      <MenuItem key={index} value={domainName}>
                        {domainName}
                      </MenuItem>
                    ))}
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                </Box>
                {inputValue && inputValue === 'other' && (
                  <div>
                    <FormikTextField autoFocus label="Domain Name" name="customDomain" required />
                  </div>
                )}
                <FormikTextField label="Email" name="email" />
                <PrimaryCheckboxInput
                  CheckboxData={CheckboxData}
                  label="Generate DNS records automatically"
                  setCheckBox={setCheckboxDataState}
                />{' '}
              </DialogContent>
              <DialogActions>
                <ActionButton onClick={handleClose} version="secondary">
                  Cancel
                </ActionButton>
                <SubmitButton
                  disabled={!isValid || !dirty}
                  isLoading={isSubmitting}
                  version="primary"
                >
                  Create
                </SubmitButton>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </FormDialog>
    );
  }

  const cpanelData = createCpanelMutation.data?.cPanel;
  const cpanelLoginNames = ['username: ', 'password: '];
  const cpanelIcons = [
    <AccountCircleIcon key={1} style={{ color: '#5564F8', fontSize: '40px' }} />,
    <VpnKeyIcon key={2} style={{ color: '#5564F8', fontSize: '40px' }} />
  ];
  const Cpanelcredentials = [
    ['1', `username: ${cpanelData.username}`],
    ['2', `password: ${cpanelData.password}`]
  ];
  const credentialsStyle = {
    bottom: '15px',
    display: 'inline-block',
    fontFamily: 'Poppins',
    margin: '5px',
    position: 'relative'
  };
  return (
    <FormDialog open={openForm}>
      <Dialog
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        onClose={() => setOpen(false)}
        open
      >
        <IconButton
          onClick={() => setOpen(false)}
          style={{ display: 'inline-block', marginLeft: '80%' }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          style={{
            fontFamily: 'Poppins',
            fontSize: '20px',
            margin: '8px',
            marginLeft: '20px',
            position: 'absolute'
          }}
        >
          Cpanel account details
        </Typography>

        <List sx={{ width: '100%' }} variant="filled">
          {Cpanelcredentials.map((email, index) => (
            <ListItem key={email[1]}>
              <ListItemText
                primary={
                  <>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                      {cpanelIcons[index]}
                    </div>
                    <div style={credentialsStyle}>{cpanelLoginNames[index]}</div>
                    <div style={credentialsStyle}>
                      <CopyContainer>
                        <Copy text={email[1].split(':')[1]} />
                      </CopyContainer>
                    </div>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </Dialog>
    </FormDialog>
  );
};

export default CpanelForm;
